module.exports = __webpack_public_path__ + "static/img/product-poster-2.da523863.png";